module.exports = __webpack_public_path__ + "static/img/tmptype4.e66dcc9b.png";